module.exports = __webpack_public_path__ + "static/media/meaningful-review-product1-full.a76a3c94.svg";